// extracted by mini-css-extract-plugin
export default {"reveal":"Reveal_reveal__RWbiU","visible":"Reveal_visible__9VLOW","revealUp":"Reveal_revealUp__lf03d"};